import { NgModule } from '@angular/core';

import { RtUICommonModule } from '../common/common.module';
import { ColorPickerComponent } from './color-picker.component';
import { ColorPickerDirective } from './color-picker.directive';
import { SliderDirective, TextDirective } from './helpers';

@NgModule({
  imports: [RtUICommonModule],
  declarations: [ColorPickerComponent, ColorPickerDirective, TextDirective, SliderDirective],
  exports: [ColorPickerDirective],
})
export class RtUIColorPickerModule {}
export { ColorPickerDirective };
